<template>
    <div class="pb-2 mt-2 rounded-xl" style="background: #fff">
        <v-row no-gutters class="d-flex justify-center align-center pt-3 pb-1"
            ><b>Informations déclarant</b></v-row
        >
        <v-row no-gutters class="d-flex justify-center align-center py-1">
            <v-col cols="11">
                <v-text-field-filled
                    :disabled="isSent"
                    outlined
                    dense
                    hide-details
                    label="Code Insee commune"
                    v-model="declaring.cityInseeCode"
                    @update:model-value="declaringHasBeenChanged()"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-center align-center py-1">
            <v-col cols="11">
                <v-text-field-filled
                    :disabled="isSent"
                    outlined
                    dense
                    hide-details
                    label="Bureau distributeur"
                    v-model="declaring.postOfficeDistributor"
                    @update:model-value="declaringHasBeenChanged()"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-center align-center py-1">
            <v-col cols="11">
                <v-text-field-filled
                    :disabled="isSent"
                    outlined
                    dense
                    hide-details
                    label="Catégorie juridique"
                    v-model="declaring.legalCategory"
                    :append-inner-icon="!declaring.legalCategory && !isSent && '$oss-help'"
                    @click:append-inner="openExternalLink()"
                    @update:model-value="declaringHasBeenChanged()"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-center align-center py-1">
            <v-col cols="11">
                <v-text-field-filled
                    :disabled="isSent"
                    outlined
                    dense
                    hide-details
                    label="Nom et prénom contact"
                    v-model="declaring.name"
                    @update:model-value="declaringHasBeenChanged()"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-center align-center py-1">
            <v-col cols="11">
                <v-text-field-filled
                    :disabled="isSent"
                    outlined
                    dense
                    hide-details
                    label="Téléphone contact"
                    v-model="declaring.phone"
                    @update:model-value="declaringHasBeenChanged()"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-center align-center py-1">
            <v-col cols="11">
                <v-text-field-filled
                    :disabled="isSent"
                    outlined
                    dense
                    hide-details
                    label="Email contact"
                    v-model="declaring.email"
                    @update:model-value="declaringHasBeenChanged()"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import { Component, Prop, toNative, Vue, Emit } from "vue-facing-decorator";
import { Declaring } from "@/services/declaration/declarationServices";

@Component({ emits: ["declaring-has-been-changed"] })
export class DeclarationManagerDeclaring extends Vue {
    @Prop({ default: null }) declaring: Declaring;
    @Prop({ default: false }) isSent: boolean;

    openExternalLink() {
        window.open("https://www.insee.fr/fr/information/2028129", "_blank");
    }

    @Emit("declaring-has-been-changed")
    declaringHasBeenChanged() {}
}

export default toNative(DeclarationManagerDeclaring);
</script>
